import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import UserListSearch from './UserList';
import UserPropsTable from './Table/UserPropTab';
import RoleTable from './Table/RoleTab';
import AppRoleTable from './Table/AppRoleTab';
import PositionsTable from './Table/PositionTab';
import RateTable from './Table/RateTab';
import { muiThemeDesign } from '../mui-theme-design';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {logger,checkAuthentication} from '../utils';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function UserTabs() {
    const [value, setValue] = React.useState(0);
    const [refresh, setRefresh] = React.useState(true);
	const [permissions, setPermissions] = React.useState({});
	React.useEffect(() => {
		checkAuthentication();
	    if (refresh) {
	        fetch('/api/User/Permission')
	            .then(res => res.json())
	            .then(json => setPermissions(json))
                .then(json => logger(`userTab Permissions- `, json))
	
	        setRefresh(false);
	    }
        logger(`UserTab Tab value-`, value)      
	})

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <MuiThemeProvider theme={muiThemeDesign}>
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs variant="scrollable" value={value} onChange={handleChange} aria-label="basic tabs example"  sx={{paddingTop: {xs:8, sm:8, md: 8, lg:8, xl: 8}}}>
                    <Tab label="User List" {...a11yProps(0)} disabled={permissions.ViewUser==0?true:false}/>
                    <Tab label="User Properties" {...a11yProps(1)} disabled={permissions.ViewUserProperties==0?true:false}/>
                    <Tab label="User Roles" {...a11yProps(2)} disabled={permissions.ViewUserRoles==0?true:false}/>
                    <Tab label="Position" {...a11yProps(3)} disabled={permissions.ViewPosition==0?true:false}/>
                    <Tab label="Rate" {...a11yProps(4)} disabled={permissions.CreateUser==0?true:false}/>
                    <Tab label="App Roles" {...a11yProps(5)} disabled={permissions.ViewAppRoles==0?true:false}/>
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <UserListSearch />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <UserPropsTable />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <RoleTable />
            </TabPanel>
            <TabPanel value={value} index={3}>
                <PositionsTable /> 
            </TabPanel>
            <TabPanel value={value} index={4}>
                <RateTable />
            </TabPanel>
            <TabPanel value={value} index={5}>
                <AppRoleTable />
            </TabPanel>
            </Box>
        </MuiThemeProvider>
    );
}